import * as React from "react";

const DirectoryIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill="#000"
      d="M17.25 1.8H6.75a2.71 2.71 0 0 0-2.7 2.7v15a2.71 2.71 0 0 0 2.7 2.7h10.5a2.71 2.71 0 0 0 2.7-2.7v-15a2.71 2.71 0 0 0-2.7-2.7m1.8 17.7a1.81 1.81 0 0 1-1.8 1.8H6.75a1.81 1.81 0 0 1-1.8-1.8v-15a1.81 1.81 0 0 1 1.8-1.8h10.5a1.807 1.807 0 0 1 1.8 1.8zM16.5 3.615h-9A1.575 1.575 0 0 0 5.925 5.19v12.435A1.575 1.575 0 0 0 7.5 19.2h9a1.575 1.575 0 0 0 1.575-1.575V5.19A1.575 1.575 0 0 0 16.5 3.615m.675 14.01a.675.675 0 0 1-.675.675h-9a.675.675 0 0 1-.675-.675V5.19A.675.675 0 0 1 7.5 4.5h9a.675.675 0 0 1 .675.675zM13.95 20.25a.45.45 0 0 1-.45.45h-3a.45.45 0 0 1 0-.9h3a.45.45 0 0 1 .45.45"
    ></path>
  </svg>
);

export default DirectoryIcon;
